define('CustomProductCollection.MainAction.View', [
    'CustomProductCollection.Model',
    'CustomProductCollection.Helper',
    'CustomProductCollection.MainAction.Children.CollectionView',
    'SCView',
    'custom_product_collection_main_action_view.tpl',
    'jQuery',
    'Backbone'
], function CustomProductCollectionMainActionViewModule(
    CustomProductCollectionModel,
    CustomProductCollectionHelper,
    CustomProductCollectionMainActionChildrenCollectionView,
    SCViewComponent,
    template,
    jQuery,
    Backbone
) {
    'use strict';

    var SCView = SCViewComponent.SCView;

    /**
     * Main controller for displaying and selecting children in CustomProductCollection.
     * @constructor
     * @param {Object} options - Initialization options for the view.
     */
    function CustomProductCollectionMainActionView(options) {
        SCView.call(this);

        this.options = options || {};
        this.template = template;
        this.attributes = {
            id: 'CustomProductCollectionMainActionView',
            'class': 'CustomProductCollection-MainAction-View'
        };

        this.model = new CustomProductCollectionModel({
            searchComponent: this.options.searchComponent,
            cartComponent: this.options.cartComponent,
            productDetailsFields: this.options.productDetailsFields
        });
        this.contextDataRequest = ['item'];
        this.model.on('change:childrenItemData', this.render, this);

        this.initMainActionView();
    }

    CustomProductCollectionMainActionView.prototype = Object.create(SCView.prototype);
    CustomProductCollectionMainActionView.prototype.constructor =
        CustomProductCollectionMainActionView;

    /**
     * Initialization logic.
     */
    CustomProductCollectionMainActionView.prototype.initMainActionView =
        function initMainActionView() {
            var pdpComponent = this.options.pdpComponent;
            var itemInfo = pdpComponent.getItemInfo();

            if (itemInfo && itemInfo.item && itemInfo.item.internalid) {
                if (itemInfo.item.custitem_cpc_is_parent_item) {
                    this.handleParentItem(itemInfo);
                } else {
                    this.handlePotentialChildItem(itemInfo);
                }
            }
        };

    /**
     * Handles logic for parent items.
     * @private
     * @param {Object} itemInfo
     */
    CustomProductCollectionMainActionView.prototype.handleParentItem = function handleParentItem(
        itemInfo
    ) {
        var self = this;
        this.model
            .fetch({ data: { parentItem: itemInfo.item.internalid } })
            .done(function afterFetchChildren() {
                var urlOptions;
                var selectedChildFromUrl;
                if (window && window.location && window.location.href) {
                    urlOptions = CustomProductCollectionHelper.parseUrlOptions(
                        window.location.href
                    );
                    selectedChildFromUrl = urlOptions ? urlOptions.item : null;
                    if (selectedChildFromUrl) {
                        self.selectChild(Number(selectedChildFromUrl));
                    } else {
                        self.selectChild(Number(self.model.get('defaultSelectedChild')), true);
                    }
                }
            });
    };

    /**
     * Handles logic for potential child items (redirect if child).
     * @private
     * @param {Object} itemInfo
     */
    CustomProductCollectionMainActionView.prototype.handlePotentialChildItem =
        function handlePotentialChildItem(itemInfo) {
            this.model
                .fetch({ data: { childItem: itemInfo.item.internalid } })
                .done(function afterFetchParentUrl(data) {
                    if (data.child && data.parentUrl) {
                        Backbone.history.navigate(
                            data.parentUrl + '?item=' + itemInfo.item.internalid,
                            {
                                trigger: true,
                                replace: true // to avoid issues when navigating back, this navigation must replace the previous one
                            }
                        );
                    }
                });
        };

    CustomProductCollectionMainActionView.prototype.getEvents = function getEvents() {
        return {
            'click [data-action="select-child"]': 'selectChildHandler',
            'keydown [data-action="select-child"]': 'selectChildKeydownHandler'
        };
    };

    CustomProductCollectionMainActionView.prototype.getChildViews = function getChildViews() {
        var model = this.model;
        var collection = model.get('childrenItemData');
        return {
            'CustomProductCollection.ProductCollection.View':
                function CustomProductCollectionProductCollectionView() {
                    return new CustomProductCollectionMainActionChildrenCollectionView({
                        collection: collection,
                        model: model
                    });
                }
        };
    };

    /**
     * Handles click for selecting a child item.
     * @param {Event} event - jQuery event.
     */
    CustomProductCollectionMainActionView.prototype.selectChildHandler =
        function selectChildHandler(event) {
            var $target = jQuery(event.currentTarget);
            var childId = $target.data('childId');
            event.preventDefault();
            this.selectChild(childId);
        };

    /**
     * Handles keyboard selection for rows.
     * @param {Event} event - Keyboard event.
     */
    CustomProductCollectionMainActionView.prototype.selectChildKeydownHandler =
        function selectChildKeydownHandler(event) {
            var $target;
            var childId;

            // Only trigger row selection if the event originated on the row, not a child element
            if (event.currentTarget !== event.target) {
                return; // Ignore bubbling key events coming from inputs/buttons inside the row
            }

            // 13 = Enter, 32 = Space
            if (event.keyCode === 13 || event.keyCode === 32) {
                event.preventDefault();
                $target = jQuery(event.currentTarget);
                childId = $target.data('childId');
                this.model.set('childIdToRestoreFocus', childId);
                this.selectChild(childId);
            }
        };

    /**
     * Selects a child and navigates the url.
     * @param {number|string} childId
     * @param {boolean} [isDefault] - If true, replaces the browser history entry (used for default selection).
     */
    CustomProductCollectionMainActionView.prototype.selectChild = function selectChild(
        childId,
        isDefault
    ) {
        var item = this.contextData.item();
        this.model.selectChild(childId);
        Backbone.history.navigate(item.urlcomponent + '?item=' + childId, {
            replace: Boolean(isDefault)
        });
    };

    /**
     * Renders the view if the model/context supports rendering.
     */
    CustomProductCollectionMainActionView.prototype.render = function render() {
        var item = this.contextData.item();
        if (CustomProductCollectionHelper.canRenderChildView(item, this.model)) {
            SCView.prototype.render.apply(this, arguments);
        }
    };

    /**
     * Returns template context.
     * @returns {Object}
     */
    CustomProductCollectionMainActionView.prototype.getContext = function getContext() {
        var item = this.contextData.item();
        return {
            description: item.storedetaileddescription
        };
    };

    return CustomProductCollectionMainActionView;
});
